import {FieldValues} from 'react-hook-form';
import React from 'react';
import {Hidden, StyledRadio,  CircleSVG, LeftWrap} from './styles.js'
import {TestingBasicLabel} from '../../../atoms/UI/forms/TestingBasicLabel/styles.js';
import TestingAnswerContent from '../TestingAnswerContent/TestingAnswerContent';
import WrongSVG from '../../../atoms/UI/forms/WrongSVG/WrongSVG';
import ErrorMessage from '../../../atoms/UI/forms/ErrorMessage/ErrorMessage';


type TestingFormRadioProps<T> = {
    type?: string | undefined;
    name: string;
    label: string;
    onChange: () => void;
    value: string | number;
    style?: string;
    disabled?: boolean;
    onAnswerClick?: (id: string | number) => void;
    imgSrc?: string;
    isCorrect?: boolean;
    isComment?: boolean;
    checked?: boolean;
    commentText?: string
    error?: string
    required?: boolean
};
const TestingFormRadio = <T extends FieldValues>({
           label,
           type,
           onChange,
           value,
           disabled,
           onAnswerClick,
           imgSrc,
           isCorrect, isComment, checked, commentText, error
       }: TestingFormRadioProps<T>) => {

    return (
        <TestingBasicLabel isDisabled={disabled}>
            <LeftWrap imgStyle={imgSrc}>
                <Hidden
                    type={type}
                    checked={checked ?? false}
                    onClick={onAnswerClick}
                    value={value ?? ''}
                    onChange={onChange}
                    disabled={disabled}
                />
                <StyledRadio isSelected={checked}>
                    {checked && (
                        typeof isCorrect !== 'undefined'
                            ? (
                                isCorrect
                                    ? <CircleSVG
                                        rightAnswer={isCorrect}
                                        viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M34.745,7.183C25.078,12.703,13.516,26.359,8.797,37.13 c-13.652,31.134,9.219,54.785,34.77,55.99c15.826,0.742,31.804-2.607,42.207-17.52c6.641-9.52,12.918-27.789,7.396-39.713 C85.873,20.155,69.828-5.347,41.802,13.379"/>
                                    </CircleSVG>
                                    : <WrongSVG />
                            ) :
                            <CircleSVG
                                viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                <path d="M34.745,7.183C25.078,12.703,13.516,26.359,8.797,37.13 c-13.652,31.134,9.219,54.785,34.77,55.99c15.826,0.742,31.804-2.607,42.207-17.52c6.641-9.52,12.918-27.789,7.396-39.713 C85.873,20.155,69.828-5.347,41.802,13.379"/>
                            </CircleSVG>
                    )
                    }
                </StyledRadio>
            </LeftWrap>

            <TestingAnswerContent
                imgSrc={imgSrc}
                label={label}
                isComment={isComment}
                commentText={commentText}
                isCorrect={isCorrect}
                isSelected={checked}
                isDisabled={disabled}
            />
            {error && <ErrorMessage>{error}</ErrorMessage>}
        </TestingBasicLabel>
    );
};

export default TestingFormRadio